var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('div',{staticClass:"loading loading-box"},[_c('LoadingSpinner'),_vm._v("ㅤ ")],1)]):(_vm.cntrctHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.cntrctHtml)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }